import { createSelector } from 'reselect'
import featureScopesSelector from './feature-scope/featureScopesSelector'

const e3dButtonShouldBeDuplicatedSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('e3dDuplicateButton'),
)

export default e3dButtonShouldBeDuplicatedSelector
